import { styled, css } from 'styled-components';
import { theme } from '../../../constants/theme.mjs';
import { Badge as Badge$1 } from '../../MicrositeHeader/components/HeaderContent/_components/SubNavigation/SubNavigation.styles.mjs';
import '../../StyleableSvgImage/index.mjs';
import { StyleableSvgImage } from '../../StyleableSvgImage/StyleableSvgImage.mjs';
"use strict";
const Container = styled.div`
  margin: 0 auto;
  max-width: 500px;
  padding: 16px;
`;
const NewLabel = styled.span`
  color: ${theme.colors.primaryBlue};
  font-size: ${theme.font.size10};
  line-height: 1;
  margin-left: 10px;
`;
const Chevron = styled(StyleableSvgImage)`
  color: #212427;
  transform: ${({
  $isRotated
}) => $isRotated ? "rotate(180deg)" : "rotate(0deg)"};
`;
const SectionItemArrowButton = styled.div`
  width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;

  transition: opacity 0.2s ease-in-out;
  opacity: 0;

  ${({
  $active
}) => $active && css`
      opacity: 1;
    `}
`;
const SectionItemLabel = styled.div`
  display: inline-block;
  gap: 4px;

  line-height: 1.2;
  text-align: left;

  font-size: ${theme.font.size21};

  ${({
  $level
}) => $level > 1 && css`
      font-size: ${theme.font.size18};
    `}

  font-weight: 700;
  color: ${theme.colors.desktopNeutral12};

  transition: color 0.2s ease-in-out;

  ${({
  $active
}) => css`
    color: ${$active ? theme.colors.primaryBlue : "#3b3f45"};
  `}
`;
const SectionItem = styled.button`
  outline: none;
  border: none;
  background-color: transparent;

  display: flex;
  align-items: center;
  gap: 4px;
  padding: 9px 16px;
  width: 100%;

  ${({
  $level
}) => $level > 1 && css`
      padding: 9px 16px 9px ${$level * 16}px;
    `}
`;
const SectionItemsGroup = styled.div`
  display: flex;
  flex-direction: column;
`;
const InnerWrap = styled.div`
  display: flex;
  flex-direction: column;
`;
const SecondLevelMenu = styled.div`
  ${({
  $level
}) => $level > 1 && css`
      padding: 6px 0;
    `}
`;
const Badge = styled(Badge$1)`
  margin-top: 0;
  margin-left: 6px;
`;
export { Badge, Chevron, Container, InnerWrap, NewLabel, SecondLevelMenu, SectionItem, SectionItemArrowButton, SectionItemLabel, SectionItemsGroup };
//# sourceMappingURL=MicrositeMobileMenu.styles.mjs.map
